export default "__VITE_ASSET__DgyG350O__"